import React, { useEffect, useRef, useState } from "react";

// Click-to-edit inline text (reconstructed — source not in kit).
// Props match every call site: value, onSave, placeholder, className,
// dataTestId, multiline.
export default function InlineEditText({
  value,
  onSave,
  placeholder = "Click to edit",
  className = "",
  dataTestId,
  multiline = false,
}) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(value || "");
  const inputRef = useRef(null);

  useEffect(() => {
    if (!editing) setDraft(value || "");
  }, [value, editing]);

  useEffect(() => {
    if (editing && inputRef.current) {
      inputRef.current.focus();
      inputRef.current.select();
    }
  }, [editing]);

  const commit = () => {
    setEditing(false);
    const v = draft.trim();
    if (v !== (value || "")) onSave?.(v);
  };

  if (!editing) {
    return (
      <button
        type="button"
        data-testid={dataTestId}
        className={`text-left bg-transparent border-0 p-0 cursor-text hover:bg-white/5 rounded px-1 -mx-1 transition-colors ${className}`}
        onClick={() => setEditing(true)}
      >
        {value ? value : <span className="opacity-50">{placeholder}</span>}
      </button>
    );
  }

  const shared = {
    ref: inputRef,
    value: draft,
    onChange: (e) => setDraft(e.target.value),
    onBlur: commit,
    onKeyDown: (e) => {
      if (e.key === "Enter" && !multiline) { e.preventDefault(); commit(); }
      if (e.key === "Escape") { setDraft(value || ""); setEditing(false); }
    },
    placeholder,
    "data-testid": `${dataTestId || "inline-edit"}-editing`,
    className: `bg-[#0a0a0a] border border-[#1a3fd1]/60 rounded px-1 -mx-1 outline-none w-full ${className}`,
  };

  return multiline ? <textarea rows={3} {...shared} /> : <input type="text" {...shared} />;
}
